// Get Stores & Users Analytics Use Case

import type {HomeAnalyticsRepository} from '../repository/HomeAnalyticsRepository';
import type {StoresUsersAnalytics} from '../models/homeAnalytics.model';

export class GetStoresUsersAnalyticsUseCase {
  constructor (private repository: HomeAnalyticsRepository) {}

  async execute (): Promise<StoresUsersAnalytics> {
    return this.repository.getStoresUsersAnalytics();
  }
}
